<template>
    <div class="menu-modal">
        <div @click="closeModal" class="svg-close-icon">
            <svg-icon icon="close-icon"/>
        </div>

        <span class="menu-modal__home-page">
            <router-link
                to="/"
                @click.native="closeModal"
                v-html="lang.logo"
            >
            </router-link>
        </span>

        <ul class="menu-links">
            <li
                v-for="link in links"
                :key="link.id"
                class="menu-link"
            >
                <router-link :to="`/${link.route}`" @click.native="closeModal">
                    {{ link.title }}
                </router-link>
            </li>
        </ul>

        <language-button @clicked="onChildClicked"/>
    </div>
</template>

<script>
import LanguageButton from '@/components/LanguageButton'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'MenuModal',
    components: {
        LanguageButton,
        SvgIcon,
    },
    computed: {
        lang() {
            return this.$parent.lang
        },
        links() {
            return [
                {
                    title: this.lang.links.stores,
                    route: 'stores',
                },
                {
                    title: this.lang.links.about,
                    route: 'about',
                },
                {
                    title: this.lang.links.contact,
                    route: 'contact',
                },
            ]
        },
    },
    methods: {
        closeModal() {
            this.$parent.toggleMenuModal()
        },
        onChildClicked(value) {
            this.$emit('newClick', value)
        },
    },
}
</script>

<style lang="scss">
.menu-modal {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-color: #001d27;

    &__home-page {
        position: absolute;
        left: 0;
        margin: 18px;

        a {
            color: white;
            font-size: 20px;
            font-weight: 700;
            text-decoration: none;

            @media (min-width: 414px) {
                font-size: 24px;
            }
        }
    }

    .svg-close-icon {
        margin: 18px;
        float: right;
    }

    .menu-links {
        margin: 78px 0 0;
        padding: 0 0 0 18px;
        text-align: left;
    }

    .menu-link {
        list-style-type: none;
        margin-bottom: 12px;
        text-transform: capitalize;

        a {
            color: white;
            font-size: 16px;
            font-weight: 400;
            text-decoration: none;

            @media (min-width: 414px) {
                font-size: 18px;
            }
        }
    }
}
</style>
